let target: "live" | "draft" = "live";

/** When draft, team saves from this page go to the unpublished user-flow copy. */
export function setUserFlowSaveTarget(next: "live" | "draft"): void {
  target = next;
}

export function getUserFlowSaveTarget(): "live" | "draft" {
  return target;
}
